import { operationInProgress, updateUser } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import SessionStorage from '../../util/sessionstore'
import { message } from 'antd'
import { fetchInProgress, serviceError } from './patient.action'

const session = new SessionStorage()

/*
Actions to be dispatched for signin
- Update Signature
    Get patient information for given company
- service error
*/

export function customerFetchInProgress(isLoading) {
  return {
    type: ActionType.CUSTOMER_INPROGRESS,
    isLoading,
  }
}

export function customerList({ customers, pagination, searchText }) {
  return {
    type: ActionType.CUSTOMER_LIST,
    customers,
    pagination,
    searchText,
    isLoading: false,
  }
}

export function fetchedCustomersIdAndNameList(customers) {
  return {
    type: ActionType.CUSTOMER_LIST,
    customers,
  }
}

export function fetchCompanyCustomers(params) {
  return async (dispatch) => {
    try {
      dispatch(customerFetchInProgress(true))
      var data = await serviceInterface
        .CustomerService()
        .fetchCompanyCustomers(params)
      dispatch(customerFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        console.log('-kio', data.customers)
        dispatch(customerList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(customerFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchCases(params) {
  return async (dispatch) => {
    try {
      dispatch(customerFetchInProgress(true))
      var data = await serviceInterface.CustomerService().fetchCases(params)
      dispatch(customerFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        dispatch(customerList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(customerFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchCustomers(params) {
  return async (dispatch) => {
    try {
      dispatch(customerFetchInProgress(true))
      var data = await serviceInterface.CustomerService().getCustomers(params)
      dispatch(customerFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        dispatch(customerList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(customerFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchCustomers2(params) {
  console.log('getcustomer2')
  return async (dispatch) => {
    try {
      dispatch(customerFetchInProgress(true))
      var data = await serviceInterface.CustomerService().getCustomers2(params)
      dispatch(customerFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        dispatch(customerList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(customerFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchCustomer(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.CustomerService().getCustomer(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getUniqueCustomerCode() {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .CustomerService()
        .getUniqueCustomerCode()
      dispatch(fetchInProgress(false))
      if (data.error) {
        return false
      } else {
        return data.accesscode
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getCustomerLogoAndName(customerid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .CustomerService()
        .getCustomerLogoAndName(customerid)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getCustomersIdAndNameList(params) {
  return async (dispatch) => {
    try {
      console.log('getCustomersIdAndNameList --------->>>', params)
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .CustomerService()
        .getCustomersIdAndNameList(params)
      console.log('data ---------->>>', data)
      dispatch(fetchInProgress(false))

      if (data.error) {
        console.log('data.error')
        dispatch(serviceError(true, data.message))
      } else {
        // data = {...data, ...params};
        // data.pagination.total = data.total;
        console.log('GTY', data)
        dispatch(fetchedCustomersIdAndNameList(data.customers))
      }
    } catch (err) {
      console.log('EOR', err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEditCustomer(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .CustomerService()
        .addEditCustomer(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        return { error: true, message: data.message }
      } else {
        return data
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      // CustomerService rejects with the server's payload when the server
      // itself refused the save - a duplicate clinic code, for instance.
      // Hand that message back so the caller can show it against the field it
      // belongs to instead of a toast that is easy to miss.
      if (err && err.error && err.message) {
        return { error: true, message: err.message }
      }
      console.log(err)
      dispatch(serviceError(true, 'error communicating with the server'))
      return false
    }
  }
}
